import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useIntl } from "react-intl";
import DraggablePaper from "./DraggablePaper";

export default function ConfirmDialog({ open, message, onConfirm, onCancel }) {
  const intl = useIntl();
  return (
    <Dialog open={open} onClose={onCancel} PaperComponent={DraggablePaper}>
      <DialogTitle data-drag-handle sx={{ cursor: "move", userSelect: "none" }}>{intl.formatMessage({ id: "common.confirm" })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message || intl.formatMessage({ id: "message.delete.confirm" })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {intl.formatMessage({ id: "common.cancel" })}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {intl.formatMessage({ id: "common.delete" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
